export function normalizeDisplayRate(displayRate) {
  if (displayRate == null) return null;
  const numericRate = Number(displayRate);
  if (!Number.isFinite(numericRate)) return null;
  if (numericRate <= 0) return 0;
  if (numericRate <= 1) return numericRate;
  if (numericRate >= 100) return 1;
  return numericRate / 100;
}

export function shouldDisplayWidget(displayRate) {
  const normalizedRate = normalizeDisplayRate(displayRate);
  if (normalizedRate == null) return true;
  if (normalizedRate === 0) return false;
  if (normalizedRate === 1) return true;
  return Math.random() < normalizedRate;
}
